module.exports = __webpack_public_path__ + "img/djk.16c64aa7.jpg";